import avatar from "assets/avatar.png";
import instgram from "assets/instgram.png";
import telegram from "assets/telegram.png";
import twitter from "assets/twitter.png";
import youtube from "assets/youtube.png";
import cn from "classnames";
import { useInitData, WebAppUser } from "@vkruglikov/react-telegram-web-app";
import { FullScreenLoader } from "components/Loading";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Link, useLocation } from "react-router-dom";

import "./index.scss";
import { login } from "services/apis/auth";
import { useAppDispatch } from "reducers";
import { updateLogin } from "reducers/auth.reducer";
import { ROUTES } from "routes/config";

export function Home() {
  const location = useLocation();
  const dispatch = useAppDispatch();
  const [isLoading, setIsLoading] = useState(true);
  const [initDataUnsafe, initData] = useInitData();

  const onSubmit = async () => {
    setIsLoading(true);
    const urlParams = new URLSearchParams(location.search);
    const inviteCode = urlParams.get('inviteCode');
    const requestData = {
      ...initDataUnsafe,
      referral: inviteCode
    }
    const response = await login(requestData);
    const { token, user, level } = response;
    dispatch(
      updateLogin({
        user: {
          id: user?.id,
          amount: user?.amount,
          level: user?.level,
          userName: initDataUnsafe?.user?.username || "",
          language: initDataUnsafe?.user?.language_code || "en",
          limit: Number(level.limit),
          from: Number(level.from),
          to: Number(level.to),
          votedAmount: Number(level.votedAmount)
        },
        token: token
      })
    );
    setIsLoading(false);
  };

  useEffect(() => {
    onSubmit();
  }, []);

  return (
    <div className="home-container">
      <div className="home-title">
        <div className="text-[#FFFEFD]">PDJ</div>
        <div className="text-[#FE3E3E]">Trump</div>
      </div>

      <div
        className={cn("home-play transition-all duration-200", {
          "-translate-y-3 opacity-0": isLoading
        })}
      >
        <div className="flex items-center w-full justify-center">
          <img src={avatar} className="w-[170px] h-[170px]" alt="" />
        </div>
        <div className="text-white text-[14px] text-center font-medium font-[Poppins] mb-[10px]">
          Vote for trump to make america great again
        </div>
        <Link
          to={ROUTES.play}
          className="flex justify-center bg-[#FE3E3E] items-center text-[21px] rounded-[12px] w-full h-[50px] text-white font-semibold font-[Poppins]"
        >
          Play
        </Link>
      </div>

      <div
        className={cn("home-bottom p-[30px] transition-all duration-200", {
          "translate-y-3 opacity-0": isLoading
        })}
      >
        <div className="text-white text-[15px] text-center font-medium font-[Poppins]">
          Save the data for PDJTrump listing
        </div>
        <div className="text-[#FE3E3E] text-[30px] text-center font-semibold font-[Poppins]">
          November 5th!
        </div>

        <div className="text-[#818181] text-[15px] text-center font-medium font-[Poppins] mt-[5px]">
          Stay tuned
        </div>
        <div className="text-white text-[15px] text-center font-medium font-[Poppins]">
          More infos in official channels
        </div>

        <div className="home-bottom-official mt-[15px]">
          <a
            href="https://www.instagram.com/pdj_trump"
            rel="noreferrer"
            target="_blank"
          >
            <img src={instgram} className="w-[33.5px] h-[33.5px]" alt="" />
          </a>

          <a
            href="https://twitter.com/pd_jtrump"
            rel="noreferrer"
            target="_blank"
          >
            <img src={twitter} className="w-[33.5px] h-[33.5px]" alt="" />
          </a>

          <a
            href="https://www.youtube.com/@PDJTrump"
            rel="noreferrer"
            target="_blank"
          >
            <img src={youtube} className="w-[33.5px] h-[33.5px]" alt="" />
          </a>

          <a href="https://t.me/Pdjtrump" rel="noreferrer" target="_blank">
            <img src={telegram} className="w-[33.5px] h-[33.5px]" alt="" />
          </a>
        </div>
      </div>

      {isLoading && <FullScreenLoader />}
    </div>
  );
}
